import {combineReducers} from "redux"
import utils from "./utils"
import conciliacion from "./conciliacion"
import empresas from "./empresas"
import corresponsales from "./corresponsales"
import ciudades from "./ciudades"
import estados from "./estados"
import abogados from "./abogados"
import usuarios from "./usuarios"
import materias from "./materias"
import tipo_autoridad from "./tipo_autoridades"
import autoridades from "./autoridades"
import convenios from "./convenios"
import objetos from "./objetos"
import notificaciones from "./notificaciones"
import desvinculaciones from "./desvinculaciones"
import tribunal from "./tribunal"
import conciliacion_status from "./conciliacion_status"
import login from "./login"
import agenda from "./agenda"
import sesiones from "./sesiones"
import terminacion from "./terminacion"
import junta from "./junta"
import configuracion_diseno from "./configuracion_diseno"
export default combineReducers({
    materias,
    convenios,
    tipo_autoridad,
    objetos,
    notificaciones,
    empresas,
    utils,
    autoridades,
    ciudades,
    estados,
    abogados,
    usuarios,
    conciliacion_status,
    desvinculaciones,
    tribunal,
    conciliacion,
    corresponsales,
    agenda,
    sesiones,
    terminacion,
    junta,
    configuracion_diseno,
    login
})